import {nowString} from "./datetime-helpers";

class CoWorkingApi {
    constructor(seamApi) {
        this.api = seamApi;
    }

    async getIndexBookingMonthAvailability(params, validationHandler = this.validationHandler) {
        return this.api.handleResponse(async  () => {
            let response = await this.api.post(`/co-working-spaces/month-availability`, params, validationHandler);
            return response.data;
        });
    }

    async getStats(params) {
        return this.api.handleResponse(async  () => {
            let response = await this.api.get(`/co-working-bookings/stats`, params);
            return response.data;
        });
    }
}


export default CoWorkingApi;
